import { postAuth, get, handleResponse, postExternal } from "./base.service";
import { CONTROLLER, ACTION } from "../utilities/api.constants";

export const getActiveMemberNumbers = () => {
    return get(CONTROLLER.PAYMENT + ACTION.GET_ACTIVE_MEMBER_NUMBER).then(handleResponse);
};

export const getActiveMemberNoLists = (paymentType) => {
    return get(CONTROLLER.PAYMENT + ACTION.GET_ACTIVE_MEMBER_NOLIST+ "?paymentType=" + paymentType ).then(handleResponse);
};

export const addPayment = (orderPayment) => {
    var data = {
        UyeNo: parseInt(orderPayment.orderdetail.memberNo),
        StartDateStr: orderPayment.orderdetail.startDate,
        MonthlyPrice: prepareMonthlyPrice(orderPayment.orderdetail.aylikTutar, orderPayment.orderdetail.aylikTutarOndalik),
        InstallmentCount: orderPayment.orderdetail.installmentCount == "" ? 0 : orderPayment.orderdetail.installmentCount,
        CreditCard: {
            CardHolderName: orderPayment.creditcard.cardHolderName,
            CardNo: orderPayment.creditcard.cardNumber,
            ExpirationMonth: parseInt(orderPayment.creditcard.expirationMonth),
            ExpirationYear: parseInt(orderPayment.creditcard.expirationYear),
            CVV: orderPayment.creditcard.cvv,
            CardType: orderPayment.creditcard.cardType,
            Bank: orderPayment.creditcard.bank,
            BankCode: orderPayment.creditcard.bankCode,
            BusinessCard: orderPayment.creditcard.businessCard
        },
        SmsCode: orderPayment.sms.sms
    };
    return postAuth(CONTROLLER.PAYMENT + ACTION.ADD_PAYMENT, data).then(
        handleResponse
    );
}


export const getPayments = (uyeNo, startDate, endDate) => {
    var data = { uyeNo, startDate, endDate };
    return get(CONTROLLER.PAYMENT + ACTION.GET_PAYMENTS + "?uyeNo=" + uyeNo + "&startDate=" + startDate + "&endDate=" + endDate).then(
        handleResponse
    );
}
export const getPaymentSummary = (uyeNo) => {
    return get(CONTROLLER.PAYMENT + ACTION.GET_PAYMENTS_SUM + "?uyeNo=" + uyeNo).then(
        handleResponse
    );
}
export const getPaymentDetail = (uyeNo, paymentId) => {
    var data = { uyeNo, paymentId };
    return get(CONTROLLER.PAYMENT + ACTION.GET_PAYMENT_DETAIL, data).then(
        handleResponse
    );
}
export const cancelPayment = (uyeNo, paymentId, itemStartDate, isPayforPayment) => {
    var data = { uyeNo, paymentId, StartDate: itemStartDate, isPayforPayment };
    return postAuth(CONTROLLER.PAYMENT + ACTION.CANCEL_PAYMENT, data).then(
        handleResponse
    );
}

const prepareMonthlyPrice = (aylikTutar, aylikTutarOndalik) => {
    if (aylikTutar == "") aylikTutar = 0;
    if (aylikTutarOndalik == "") aylikTutarOndalik = 0;
    return parseFloat(aylikTutar + '.' + aylikTutarOndalik)
}

export const binSearch = (cardNo) => {
    return get(CONTROLLER.PAYMENT + ACTION.BIN_SEARCH + "?value=" + cardNo).then(handleResponse);
};

export const addPaymentPayTr = (amount, installment_count, member_no, card_type, cc_owner, card_number, expiry_month, expiry_year, cvv) => {
    var data = { amount, installment_count, member_no, card_type, cc_owner, card_number, expiry_month, expiry_year, cvv };
    return postAuth(CONTROLLER.PAYMENT + ACTION.ADD_PAYMENT_PAYTR, data).then(
        handleResponse
    );
}

export const getTokenPayTriframe = (amount, installment_count) => {
    var data = { amount, installment_count };
    return postAuth(CONTROLLER.PAYMENT + ACTION.GET_IFRAME_TOKEN_PAYTR, data).then(
        handleResponse
    );
}

export const getPaymentPlanePayTr = (amount, cardType, paymentType, bank, bankCode, businessCard, uyeNo ) => {
    var data = { amount, cardType, paymentType, bank, bankCode, businessCard, uyeNo };
    return postAuth(CONTROLLER.PAYMENT + ACTION.GET_PAYMENT_PLANE_PAYTR, data).then(
        handleResponse
    );
}
export const getPaymentPlaneEminPay = (cardBinNumber, amount, paymentType, cardType, uyeNo ) => {
    var data = { cardBinNumber , amount, paymentType, cardType, uyeNo};
    return postAuth(CONTROLLER.PAYMENT + ACTION.GET_PAYMENT_PLANE_EMIN_PAY, data).then(
        handleResponse
    );
}
export const binSearchEminPay = (cardBinNumber) => {
    var data = { cardBinNumber };
    return postAuth(CONTROLLER.PAYMENT + ACTION.BIN_SEARCH_EMIN_PAY, data).then(
        handleResponse
    );
};
